module.exports = __webpack_public_path__ + "assets/images/1$B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$B-route-sheet.png
// module id = 1269
// module chunks = 1